import React from "react";

const Mission = () => {
  return (
    <>
      <section className="my-10">
        <div className="flex flex-col container mx-auto px-4 gap-10 lg:flex-row">
          <div className="flex flex-col space-y-2 w-full lg:w-1/2">
            <p className="text-2xl font-semibold opacity-80 sm:text-3xl lg:text-4xl text-black">
              Our Mission
            </p>
            <p className="text-md lg:text-xl text-black opacity-80">
              To constantly provide best IT Solutions and services in the world that exceeds the customer's satisfaction
            </p>
          </div>

          <div className="flex flex-col space-y-2 w-full lg:w-1/2">
            <p className="text-2xl font-semibold opacity-80 sm:text-3xl lg:text-4xl text-black">
              Our Vision
            </p>
            <p className="text-md lg:text-xl text-black opacity-80">
              To be globally recognized as a leader in technology solutions and
              management consulting through our excellent revolutionary customer
              service, innovation, technical superiority and world class
              quality.
            </p>
          </div>
        </div>
      </section>
      <div className="h-28 w-full bg-black bg-opacity-[0.05]">

      </div>
    </>
  );
};

export default Mission;
